<template>
    <div style="text-align: left">
        <div class="list">退款管理</div>
        <div class="content">
            <div class="goods">
                <div style="flex:2;display: flex; ">
                    <div class="search">
                        状态：<el-select clearable @change="stateSearch" v-model="Refund.refundApproval"
                            placeholder="请选择订单状态" style="width:200px">
                            <el-option v-for="(item, index) in orderState" :key="index" :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        订单号：<el-input style="width:200px" v-model="Refund.orderCode"></el-input>
                        开始时间：<div class="startTime">
                            <el-date-picker v-model="Refund.startTime" value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" @change="resetTime">
                            </el-date-picker>
                        </div>
                        结束时间：<div class="startTime">
                            <el-date-picker v-model="Refund.endTime" value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间"
                                :disabled="Refund.startTime === null ? true : false">
                            </el-date-picker>
                        </div>

                        <el-button type="primary" style="margin-left:10px" @click="orderSearch">搜 索</el-button>
                        <el-button @click="resetGetRefundList" type="primary" plain>重 置</el-button>
                    </div>
                </div>
                <br />
                <hr>

            </div>
            <br />
            <div class="global-table-box">
                <el-table :data="tableData" border style="width: 100%" :cell-style="{}" header-align="center">
                    <el-table-column type="selection" width="55" align="center">
                    </el-table-column>
                    <el-table-column type="index" width="50" label="序号" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="orderCode" label="订单号" header-align="center" align="center" width="300">
                    </el-table-column>
                    <el-table-column prop="createTime" label="申请时间" header-align="center" align="center" width="300">
                    </el-table-column>
                    <el-table-column v-if="Refund.refundTime == 1 || ''" prop="refundTime" label="退款时间"
                        header-align="center" align="center" width="300">
                    </el-table-column>
                    <el-table-column label="订单状态" header-align="center" align="center" width="100">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.refundApproval === 0" type="danger">已拒绝</el-tag>
                            <el-tag v-if="scope.row.refundApproval === 1" type="success">已退款</el-tag>
                            <el-tag v-if="scope.row.refundApproval === 2">待审核</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="退款总金额" header-align="center" align="center" width="100">
                        <template slot-scope="scope">
                            {{ scope.row.refundAmount }}￥
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="退款原因" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="refundOpinion" label="审批意见" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column label="退款状态" header-align="center" align="center" width="100">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.refundSuccess === 0" type="danger">退款失败</el-tag>
                            <el-tag v-if="scope.row.refundSuccess === 1" type="success">退款成功</el-tag>
                            <el-tag v-if="scope.row.refundSuccess === 2">未知</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="200" header-align="center" align="center">
                        <template slot-scope="scope">
                            <!-- <el-button type="text" size="small" :disabled="scope.row.refundApproval == 2 ? false : true"
                                @click="consentWxRefund(scope.row, 1)">同 意</el-button> -->
                            <el-button type="text" size="small" @click="openRefund(scope.row, 2)"
                                :disabled="(scope.row.refundApproval == 2 ? false : true)">拒
                                绝</el-button>
                            <el-button type="text" v-if="(scope.row.refundApproval === 1 && scope.row.refundSuccess === 0)"
                                size="small" @click="wxRefund(scope.row, 2)"
                                :disabled="(scope.row.refundApproval === 1 ? (scope.row.refundSuccess === 0? false : true) : true)">退款</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="block1">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="Refund.pageNum"
                    :page-size="Refund.pageSize" layout="prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- :before-close="handleClose" -->
        <el-dialog :title="fontStyle" :visible.sync="dialogVisible" width="30%">
            <div class="textarea">
                <span>处理意见：</span>
                <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="refundState.refundOpinion">
                </el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <!-- <el-button type="primary" @click="confirmRefund">确 定</el-button> -->
            </span>
        </el-dialog>

    </div>

</template>

<script>
import request from '../utils/request'
export default {
    data() {
        return {
            // 查询退款列表
            Refund: {
                isPage: true,
                pageNum: 1,
                pageSize: 10,
                refundApproval: '', //0 已拒绝， 1已退款， 2待审核 
                startTime: null,
                endTime: null,
                orderCode: ''
            },
            tableData: [],
            // 订单状态管理
            orderState: [{
                name: '全部',
                value: ''
            },
            {
                name: '已拒绝',
                value: '0'
            },
            {
                name: '已退款',
                value: '1'
            },
            {
                name: '待审核',
                value: '2'
            },],
            // 总条数
            total: 0,
            // 是否同意退款列表
            refundState: {
                orderCode: "",
                refundApproval: "",
                refundOpinion: "",
            },
            // 退款弹窗开关
            dialogVisible: false,
            // 退款不退款
            fontStyle: ''
        }
    },
    methods: {
        // 退款列表
        async getRefundList() {
            const res = await request({
                method: 'POST',
                url: 'admin/wx/getWxRefund',
                data: this.Refund
            })
            if (res.code === '200') {
                // //console.log(res);
                // this.$message.success(res.message)
                this.total = res.data.total
                this.tableData = res.data && res.data.list
            } else {
                //console.log(res);
                this.$message.error(res.message)
            }
        },
        // 订单状态查询
        stateSearch(item) {
            this.reset()
            //console.log(item);
            this.Refund.refundApproval = item
            this.Refund.pageNum = 1
            //this.getRefundList()
        },
        //重置查询订单数据
        reset() {
            this.Refund.endTime = null
            this.Refund.pageNum = 1
            this.Refund.pageSize = 10
            this.Refund.refundApproval = ''
            this.Refund.startTime = null
            this.Refund.orderCode = ''
        },
        //订单查询
        orderSearch() {
            this.Refund.pageNum = 1
            //this.getRefundList()
        },
        // 重置
        resetGetRefundList() {
            this.reset()
            //this.getRefundList()
        },
        // 分页器
        handleCurrentChange() {
            //this.getRefundList()
        },
        // 打开退款弹窗
        openRefund(val, f) {
            this.resetConfirmRefund()
            this.dialogVisible = true
            //console.log(val);
            this.refundState.orderCode = val.orderCode
            if (f === 1) {
                this.fontStyle = '同意退款'
                this.refundState.refundApproval = 1
            } else {
                this.fontStyle = '拒绝退款'
                this.refundState.refundApproval = 0
            }

            // this.$confirm('确认退款？')
            //     .then(() => {
            //     })
            //     .catch(() => { });
        },
        // 确认退款
        async confirmRefund() {
            this.dialogVisible = false
            const res = await request({
                method: 'POST',
                url: 'admin/wx/setWxRefund',
                data: this.refundState
            })
            //console.log(res);
            if (res.code === '200') {
                this.$message.success(res.message)
                //this.getRefundList()
            } else {
                this.$message.error(res.message)
            }
        },
        // 退款
        async wxRefund(val){
            const res = await request({
                method: 'GET',
                url:`admin/wx/refund?orderCode=${val.orderCode}`
            })
            if (res.code === '200') {
                this.$message.success(res.message)
                //this.getRefundList()
            }else{
                this.$message.error(res.message)
                //this.getRefundList()
            }
        },
        // 同意退款
        async consentWxRefund(val){
            const res = await request({
                method: 'GET',
                url: `admin/wx/consentWxRefund?refundId=${val.id}`
            })
            if(res.code === '200'){
                this.wxRefund(val)
            }else{
                this.$message.error(res.message)
            }
        },
        // 重置退款表单
        resetConfirmRefund() {
            this.refundState.orderCode = ''
            this.refundState.refundApproval = ''
            this.refundState.refundOpinion = ''
        },
        // 重置查询列表
        resetTime() {
            //console.log(this.Refund.startTime);
            this.Refund.endTime = ''
        }
    },
    created() {
        //this.getRefundList()
    }
}
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
    // display: flex;
    justify-content: space-between;


    .input-with-select {
        padding: 0;
    }
}

.search {
    line-height: 40px;
}

.block1 {
    background-color: #fff;
    text-align: right;
}

.startTime {
    display: inline-block;
    width: 200px;
    margin-right: 20px;

    .el-date-picker {
        width: 200px;
    }

    input {
        width: 200px;
    }
}

.textarea {
    display: flex;
    justify-content: space-between;
    flex: 100;
    align-items: center;

    .el-textarea.el-input--small {
        flex: 50;
    }
}
</style>